export default __webpack_public_path__ + "static/media/revoke-cancelled-icon.bd119680.svg";